"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var YotpoPagination_1 = require("./YotpoPagination");
var YotpoReviewCard_1 = require("./YotpoReviewCard");
var YotpoReviewMain = function (_a) {
    var _b;
    var featuredReviewsData = _a.featuredReviewsData, searchReviewData = _a.searchReviewData, queryParams = _a.queryParams, searchParams = _a.searchParams, setQueryParams = _a.setQueryParams;
    var originalReviews = searchReviewData.reviews;
    var featuredReviews = featuredReviewsData || [];
    var reviewsToBeDisplayed = __spreadArray(__spreadArray([], featuredReviews, true), originalReviews, true);
    // If the search function and score filter is called, the score array's length is not 0
    // and free_text_search string is not undidentified, the review list is set to be the
    // searched or/and filtered reviews
    if ((searchParams.scores && ((_b = searchParams.scores) === null || _b === void 0 ? void 0 : _b.length) > 0) || searchParams.free_text_search) {
        reviewsToBeDisplayed = originalReviews;
    }
    else {
        // handle featured reviews pagination
        if (queryParams.page) {
            // This logic overwrite the original reviews with featured reviews.
            // If there are 3 featured reviews, the first 3 original
            // reviews are replaced by the featured reviews and never rendered.
            if (queryParams.page <= Math.ceil(featuredReviews.length / searchReviewData.pagination.per_page)) {
                reviewsToBeDisplayed = reviewsToBeDisplayed.slice(searchReviewData.pagination.per_page * (queryParams.page - 1), searchReviewData.pagination.per_page * queryParams.page);
            }
            else {
                reviewsToBeDisplayed = originalReviews;
            }
        }
    }
    return ((0, preact_1.h)(preact_1.Fragment, null,
        originalReviews.length > 0 ? (reviewsToBeDisplayed.map(function (review) { return (0, preact_1.h)(YotpoReviewCard_1.default, { review: review, key: review.id }); })) : ((0, preact_1.h)("p", null, "There is no review for this product yet!")),
        (0, preact_1.h)(YotpoPagination_1.default, { pagination: featuredReviews.length && queryParams.page
                ? __assign(__assign({}, searchReviewData.pagination), { page: queryParams.page }) : searchReviewData.pagination, setQueryParams: setQueryParams })));
};
exports.default = YotpoReviewMain;
